export function Field({ label, id, hint, children }) {
  return (
    <div className="space-y-1.5">
      <label htmlFor={id} className="block text-sm font-medium text-eden-text">{label}</label>
      {children}
      {hint && <p className="text-xs text-eden-muted">{hint}</p>}
    </div>
  );
}

export function TextInput({ id, value, onChange, ...rest }) {
  return <input id={id} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="input-eden" data-testid={`input-${id}`} {...rest} />;
}

export function TextArea({ id, value, onChange, rows = 4, ...rest }) {
  return <textarea id={id} value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={rows} className="input-eden resize-y" data-testid={`textarea-${id}`} {...rest} />;
}

export function Panel({ title, description, children }) {
  return (
    <section className="card-eden p-6 sm:p-8">
      <h2 className="font-display text-lg font-semibold text-eden-text">{title}</h2>
      {description && <p className="mt-1 text-sm text-eden-muted">{description}</p>}
      <div className="mt-6 space-y-5">{children}</div>
    </section>
  );
}
